import { gql, useMutation } from "@apollo/client";
import type {
    HideTranslationSupportCalloutMutationVariables,
    HideTranslationSupportCalloutMutation,
} from "./__generated__/useHideTranslationCalloutMutation";

export const HIDE_TRANSLATION_CTA_MUTATION = gql`
    mutation HideTranslationSupportCallout($userPublicId: String, $linkHash: String) {
        hideTranslationSupportCallout(userPublicId: $userPublicId, linkHash: $linkHash) {
            success
            errors
        }
    }
`;

type Props = {
    variables: HideTranslationSupportCalloutMutationVariables;
};

export function useHideTranslationCalloutMutation({ variables }: Props) {
    return useMutation<
        HideTranslationSupportCalloutMutation,
        HideTranslationSupportCalloutMutationVariables
    >(HIDE_TRANSLATION_CTA_MUTATION, { variables });
}
